'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useModal } from 'components/shared/Modal';
import { UhAppModal } from 'components/shared/UHAppDownloadModal';
import {
  appHandoffUrl,
  storeUrlForDevice,
  tryOpenUltrahumanApp,
} from 'components/landing/v3/openUltrahumanApp';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { getBloodVisionBooking } from 'content/products/bloodVisionBookingRegions';
import { getAssetUrl } from 'lib/config/assetUrls';

const APP_BOOKING_DEEPLINK =
  'ultrahuman://medical_test_order_flow?utm_source=bv_uae_pricing_page';
const APP_BOOKING_QR = getAssetUrl('/web_v2/qr-codes/blood-vision-qr.png');

export const useBloodVisionBooking = () =>
  getBloodVisionBooking(useRegionLocale().region);

// Phones try the order-flow deeplink, then the store if the app does not
// open. Desktop shows the App Store modal with the Blood Vision QR.
export const useBookBloodVisionInApp = () => {
  const t = useTranslations('common');
  const modal = useModal();

  return useCallback(() => {
    const storeUrl = storeUrlForDevice();
    if (storeUrl && tryOpenUltrahumanApp(storeUrl, APP_BOOKING_DEEPLINK)) {
      return;
    }
    modal.setBg('');
    modal.setPortal(false);
    modal.set(
      <UhAppModal
        heading={t('bloodVisionBooking.appModal.heading')}
        text={t('bloodVisionBooking.appModal.text')}
        link={appHandoffUrl('ios')}
        qr={
          <img
            src={APP_BOOKING_QR}
            width={132}
            height={132}
            alt={t('bloodVisionBooking.appModal.qrAlt')}
          />
        }
      />,
    );
    modal.show();
  }, [modal, t]);
};
